export const confidenceLevels = {
  High: _TL_('High'),
  Low: _TL_('Low'),
  Medium: _TL_('Medium'),
};

export const getConfidenceLevel = (value) => {
  if (confidenceLevels[value] == null) {
    return _TL_('Invalid confidence level');
  }
  return confidenceLevels[value];
};
